import Vue from 'vue';
import VueI18n from 'vue-i18n';
import * as en from './en.json';
import * as fr from './fr.json';
import isFr from './isFr';

Vue.use(VueI18n);

const currentLocalCode = isFr || window.location.pathname === '/' ? 'fr' : 'en';
const oppositeLocalCode = currentLocalCode === 'en' ? 'fr' : 'en';
const html = document.documentElement;
html.setAttribute('lang', currentLocalCode);

export default new VueI18n({
	locale: currentLocalCode,
	opposite: oppositeLocalCode,
	messages: {
		en: en.default,
		fr: fr.default,
	},
	silentTranslationWarn: true,
});
